import update from 'immutability-helper';
import { setDefaultLandingPageWhenEmpty } from '@utils/setDefaultLandingPage';
import * as types from './types';

const initialState = {
  url: '',
  name: '',
  path: '',
  customerId: null,
  showPrompt: false,
  promptTitle: '',
  promptContent: '',
  promptNeedInput: false,
  promptOkFn: () => undefined,
  tmpPayload: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
  case types.UPDATE_DEFAULT_LANDING_PAGE:
  case types.GET_DEFAULT_LANDING_PAGE_SUCCESS: {
    const payload = setDefaultLandingPageWhenEmpty(action.payload, state.customerId);
    const { url = '', name = '', path = '' } = payload;
    return update(state, {
      url: { $set: url },
      name: { $set: name },
      path: { $set: path },
    });
  }
  case types.SET_DEFAULT_LANDING_PAGE: {
    const payload = setDefaultLandingPageWhenEmpty(action.payload, state.customerId);
    const { url, name, path } = payload;
    return update(state, {
      url: { $set: url },
      name: { $set: name },
      path: { $set: path },
    });
  }
  case types.SHOW_PROMPT: {
    return update(state, {
      showPrompt: { $set: true },
    });
  }
  case types.HIDE_PROMPT: {
    return update(state, {
      showPrompt: { $set: false },
    });
  }
  case types.SET_PROMPT_TITLE: {
    const title = action.payload;
    return update(state, {
      promptTitle: { $set: title },
    });
  }
  case types.SET_PROMPT_CONTENT: {
    const content = action.payload;
    return update(state, {
      promptContent: { $set: content },
    });
  }
  case types.SET_PROMPT_NEED_INPUT: {
    const needInput = action.payload;
    return update(state, {
      promptNeedInput: { $set: needInput },
    });
  }
  case types.SET_PROMPT_OK_FN: {
    const okFn = action.payload;
    return update(state, {
      promptOkFn: { $set: okFn },
    });
  }
  case types.SET_TMP_PAYLOAD: {
    const tmpPayload = action.payload;
    return update(state, {
      tmpPayload: { $set: tmpPayload },
    });
  }
  case types.SET_CUSTOMER_ID: {
    const id = action.payload;
    return update(state, {
      customerId: { $set: id },
    });
  }
  default:
    return state;
  }
};
